
import { Link } from "react-router-dom";
import { DateTime } from 'luxon';

function ActivityRow ( { activity } ) 
{
    let dt = DateTime.fromISO ( activity.createdAt ).toFormat ( 'MMM dd HH:mm' );

    return  <tr className="border-b border-dashed border-pgdarkteal">
                <td className="text-right whitespace-nowrap py-2">
                    {Number ( activity.distance ).toFixed ( 1 )} km
                </td>
                <td className="whitespace-nowrap py-2">
                    <Link to={activity.id} className="font-normal">
                        {activity.name} {activity.participants > 1 ? " (" + activity.participants + " participants)" : null}
                    </Link>
                </td>
                <td className="text-right w-full py-2">
                    {dt}
                </td>
            </tr>
}

export default ActivityRow;